import { HttpParams, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

export interface Pagination {
  page: number;
  size: number;
  sort: string[];
}

export const createRequestOption = (req?: any): HttpParams => {
  let options: HttpParams = new HttpParams();

  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort') {
        options = options.set(key, req[key]);
      }
    });

    if (req.sort) {
      req.sort.forEach((val: string) => {
        options = options.append('sort', val);
      });
    }
  }

  return options;
};

export const mapAsBody = map(<T>(httpResponse: HttpResponse<T>) => httpResponse.body!);
